import { createContext } from "react";

import { Encounter, Patient, Reference } from "@medplum/fhirtypes";

import { EncounterDrawerFormsStack } from "@/encounters/constants/encounter-drawer-forms-stack";
import { EncounterFormType } from "@/encounters/zod-schemas/encounters";

interface CreateEncounterContextOptions {
  encounter: Encounter | undefined;
  initialValues: EncounterFormType | undefined;
  handleOpenEncounterDrawerWithEncounter: (
    id: EncounterDrawerFormsStack,
    encounter?: Encounter,
  ) => void;
  handleOpenEncounterDrawerWithInitialValues: (
    id: EncounterDrawerFormsStack,
    initialValues: EncounterFormType,
  ) => void;
  clearEncounterAndInitialValues: () => void;
  statusChanged: boolean;
  setStatusChanged: React.Dispatch<React.SetStateAction<boolean>>;
  setNewbornIPPEncounterInitialValuesAndOpenDrawer: () => void;
  registerEncounterUpdateListener: (listener: (encounter: Encounter) => void) => () => void;
  notifyEncounterUpdateListeners: (encounter: Encounter) => void;
  /** Newborn selected for the standalone Newborn IPP creation flow's picker (B2a). */
  selectedNewbornReference: Reference<Patient> | undefined;
  setSelectedNewbornReference: React.Dispatch<React.SetStateAction<Reference<Patient> | undefined>>;
}

export const CreateEncounterContext = createContext<CreateEncounterContextOptions>({
  encounter: undefined,
  initialValues: undefined,
  handleOpenEncounterDrawerWithEncounter: () => null,
  handleOpenEncounterDrawerWithInitialValues: () => null,
  clearEncounterAndInitialValues: () => null,
  statusChanged: false,
  setStatusChanged: () => null,
  setNewbornIPPEncounterInitialValuesAndOpenDrawer: () => null,
  registerEncounterUpdateListener: () => () => {},
  notifyEncounterUpdateListeners: () => {},
  selectedNewbornReference: undefined,
  setSelectedNewbornReference: () => null,
});
